import { ShopperAiSettingsOptimizationSchema } from "@redotech/redo-model/shopper-ai-settings-optimization";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getShopperAiSettingsOptimization = {
  name: "getShopperAiSettingsOptimization" as const,
  input: z.null(),
  output: zExt.filterToValidArray(ShopperAiSettingsOptimizationSchema),
};
